/** Signaling protocol version. Bump on any incompatible message change. */
export const PROTOCOL_VERSION = 3;

/**
 * Protocol spoken by the AMG Support helper (the Windows app). Versioned separately from web
 * pages, because installed apps update less often than pages reload. Version 1 was the earlier,
 * much larger app that captured the screen itself; it is refused and told to update.
 */
export const AGENT_PROTOCOL_VERSION = 2;

/** URL scheme the Windows helper registers; the portal opens it with a one-time pairing ticket. */
export const AGENT_URL_SCHEME = 'amg-support';

export const LIMITS = {
  nameMax: 60,
  titleMax: 80,
  chatMax: 1000,
  emailMax: 254,
  passwordMin: 10,
  passwordMax: 200,
  sdpMax: 24_000,
  candidateMax: 1_024,
  clientIdMax: 64,
  /** Hard cap on a single WebSocket frame. */
  wsMaxPayload: 64 * 1024,
  /** Computer name reported by the Windows helper (display only). */
  deviceMax: 60,
  agentVersionMax: 32,
} as const;

/** Application WebSocket close codes (4000-4999 are reserved for applications). */
export const CloseCode = {
  /** Protocol violation or unsupported version: do not retry blindly. */
  protocol: 4000,
  /** The same participant connected from another tab or device. */
  replaced: 4001,
  /** Removed by the host or credentials no longer valid. */
  forbidden: 4003,
  /** Session ended. */
  ended: 4004,
  /** Too many messages. */
  policy: 4008,
  /** Lobby closed: request declined, expired or cancelled. */
  lobbyClosed: 4009,
  /** The participant left voluntarily. */
  left: 4010,
} as const;

/** Close codes after which the client must not reconnect automatically. */
export const FINAL_CLOSE_CODES: ReadonlySet<number> = new Set([
  CloseCode.protocol,
  CloseCode.replaced,
  CloseCode.forbidden,
  CloseCode.ended,
  CloseCode.lobbyClosed,
  CloseCode.left,
]);
